module.exports = __webpack_public_path__ + "img/one.24d8d42f.png";